module.exports = __webpack_public_path__ + "static/DSC_9234-8f9dd9847b86aab3c4e99965fff6f5e0.jpg";